import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const ChatListNavUI = ({ context, page }) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      {/* <TabLinkUI label='Recent' to='/su/chats/recent' active={page === 'recent'} />
      <TabLinkUI label='To Follow Up' to='/su/chats/followUp' active={page === 'followUp'} /> */}
    </div>
    <div className='g_m_top_50' />
  </div>

export default ChatListNavUI